import axiosInstance from "auth/FetchInterceptor";
import { KY_THI__API, DANH_SACH_BAI_THI__API } from "constants/ApiConstant";

const ThiCuoiKyService = {};

ThiCuoiKyService.create = function (data) {
  return axiosInstance.post(`${KY_THI__API}`, data);
};

ThiCuoiKyService.create = function (data) {
  return axiosInstance.post(`${KY_THI__API}`, data);
};

ThiCuoiKyService.getDanhSachKyThi = function (type) {
  return axiosInstance.get(`${KY_THI__API}?type=${type}`);
};

ThiCuoiKyService.huyNopBaiThi = function (id) {
  return axiosInstance.delete(`${KY_THI__API}/huy-bai-thi?id=${id}`);
};

ThiCuoiKyService.getDanhSachDeThi = function (type) {
  return axiosInstance.get(`${DANH_SACH_BAI_THI__API}/search?type=${type}`);
};

ThiCuoiKyService.createBaiThi = function (data) {
  return axiosInstance.post(`${DANH_SACH_BAI_THI__API}`, data);
};

ThiCuoiKyService.chiTietBaiThi = function (data) {
  return axiosInstance.post(`${KY_THI__API}/chi-tiet`, data);
};

ThiCuoiKyService.danhSachBaiThiDaNop = function (data) {
  return axiosInstance.post(`${KY_THI__API}/search`, data);
};

ThiCuoiKyService.chamThi = function (data) {
  return axiosInstance.post(`${KY_THI__API}/cham-thi`, data);
};

ThiCuoiKyService.getImportByTransId = function (transId) {
  return axiosInstance.get(`${KY_THI__API}/get-import-details?id=${transId}`);
};

ThiCuoiKyService.importByTransId = function (transId) {
  return axiosInstance.get(`${KY_THI__API}/import-excel?id=${transId}`);
};

ThiCuoiKyService.importSynce = function (data) {
  return axiosInstance.put(
    `${KY_THI__API}/import-synce?id=${data.transId}`,
    data.ids,
  );
};

ThiCuoiKyService.yeuCauPhucKhao = function (data) {
  return axiosInstance.post(`${KY_THI__API}/yeu-cau-phuc-khao`, data);
};

ThiCuoiKyService.phanHoiPhucKhao = function (data) {
  return axiosInstance.put(`${KY_THI__API}/cham-thi-lai`, data);
};
ThiCuoiKyService.danhSachViecTuTeDaNop = function (data) {
  return axiosInstance.post(`${KY_THI__API}/search-viec-tu-te`, data);
};

ThiCuoiKyService.chiTietBaiThiById = function (id) {
  return axiosInstance.get(`${KY_THI__API}/chi-tiet-bai-thi?Id=${id}`);
};

export default ThiCuoiKyService;
